import { createSelector } from '@ngrx/store';
import { NewsCategory } from '@pt/models';

import { supportFeature } from './support.reducers';

const {
  selectCategories,
  selectCategoryId,
  selectTipType,
  selectGetCategoriesAction,
  selectGetTipsAction,
  selectSendMessageAction,
} = supportFeature;

export interface SupportViewModel {
  categories: NewsCategory[];
  categoryId: number;
  tipType: string;
  isLoading: boolean;
}

const selectViewModel = createSelector(
  selectCategories,
  selectCategoryId,
  selectTipType,
  selectGetCategoriesAction,
  selectGetTipsAction,
  selectSendMessageAction,
  (
    categories,
    categoryId,
    tipType,
    getCategoriesAction,
    getTipsAction,
    sendMessageAction,
  ): SupportViewModel => ({
    categories: categories.categories
      .map(category => ({ ...category, name: category.name.trim()
        .replace(' ', '_').toLowerCase() })),
    categoryId,
    tipType,
    isLoading: getCategoriesAction.inProgress
      || getTipsAction.inProgress
      || sendMessageAction.inProgress,
  }),
);

export const SupportSelectors = {
  selectCategories,
  selectCategoryId,
  selectTipType,
  selectGetCategoriesAction,
  selectGetTipsAction,
  selectSendMessageAction,
  selectViewModel,
};
